import { Component } from '../../../libs/gin-tonic/helpers/compiler';
import { OverlayImplementation, OverlayOptions, OverlayPositionBuilder } from '../../../libs/gin-tonic/helpers/overlay';

@Component({ className: 'js-tooltip' })
export class TooltipComponent {
	constructor(element: HTMLElement) {
		new Tooltip(element);
	}
}

class Tooltip extends OverlayImplementation {
	private cachedTitleTag: string;
	private elementRemovalObserver?: MutationObserver;

	constructor(element: HTMLElement) {
		super(element);
		this.cachedTitleTag = this.element.title;
		this.element.title = '';
		this.element.addEventListener('mouseenter', e => this.open(e.target as HTMLElement));
		this.element.addEventListener('mouseleave', () => this.close());
	}

	override open(trigger?: HTMLElement): void {
		this.startElementRemovalObserver();
		super.open(trigger);
	}

	override close(): void {
		super.close();
		this.stopElementRemovalObserver();
	}

	getOverlayOptions(): OverlayOptions {
		return {
			positionStrategy: OverlayPositionBuilder.connectedTo(this.element)
				.withFallbackPosition(
					{
						originX: 'center',
						originY: 'top'
					},
					{
						overlayX: 'center',
						overlayY: 'bottom'
					}
				)
				.withFallbackPosition(
					{
						originX: 'center',
						originY: 'bottom'
					},
					{
						overlayX: 'center',
						overlayY: 'top'
					}
				),
			overlayClassName: 'c-tooltip__panel',
			portalClassName: 'c-tooltip',
			hasBackdrop: false,
			disposeAfterClose: true
		};
	}

	initializePortal(portal: HTMLElement): void {
		portal.innerHTML = this.cachedTitleTag;
	}

	private startElementRemovalObserver(): void {
		if (this.elementRemovalObserver) {
			return;
		}

		this.elementRemovalObserver = new MutationObserver(() => {
			if (!this.element.isConnected) {
				this.close();
			}
		});

		this.elementRemovalObserver.observe(document.body, {
			childList: true,
			subtree: true
		});
	}

	private stopElementRemovalObserver(): void {
		this.elementRemovalObserver?.disconnect();
		this.elementRemovalObserver = undefined;
	}
}
